module.exports = __webpack_public_path__ + "img/ausstellung6.43e397c5.jpg";